// Theme provider using Digital HIG light theme
import React, { ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
// @ts-ignore - Digital HIG components
import { themeLight } from '@digital-hig/mui/Theme';
import { createTheme, ThemeProvider } from '@mui/material/styles';

interface CustomThemeProviderProps {
  children: ReactNode;
}

const light = createTheme(themeLight as any);

export const CustomThemeProvider: React.FC<CustomThemeProviderProps> = ({ children }) => {
  return (
    <ThemeProvider theme={light}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

